module.exports = __webpack_public_path__ + "media/images/menu-settings-icon-37875cc7802696cb491e5afbd65f5923.svg";